import { render, staticRenderFns } from "./MobileTabs.vue?vue&type=template&id=7b8931c4&scoped=true"
import script from "./MobileTabs.vue?vue&type=script&lang=js"
export * from "./MobileTabs.vue?vue&type=script&lang=js"
import style0 from "./MobileTabs.vue?vue&type=style&index=0&id=7b8931c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8931c4",
  null
  
)

export default component.exports